import React, { Component } from 'react';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconQuote } from '../../media/icons/quote.svg';


export default class Testimonials extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            number: 0
        };

    }


    setPage(page_in) {
        var max_page = this.props.data.length;
        var page = page_in;
        var page = page > (max_page - 1) ? 0 : page;
        var page = page < 0 ? (max_page - 1) : page;
        this.setState({
            number: page
        })
    }


    render() {

        return (
            <div className="testimonials-container">
                <h2 className="home__title text-title">
                    Hear from our users
                </h2>
                {(this.props.data && this.props.data.length >= 1) &&
                    <div className="testimonials-wrapper">
                        <div className="testimonials__content-container">

                            <div onClick={() => this.setPage(this.state.number - 1)} className="testimonials__content__arrow testimonials__content__arrow--left">
                                <IconArrow className="testimonials__content__arrow-inner" />
                            </div>

                            {(this.props.data && this.props.data.length >= 1) && this.props.data.map((element, i) =>
                                <div key={i} className={"testimonials__content" + (i !== this.state.number ? " testimonials__content--hidden" : "")}>
                                    <div className="testimonials__content__top">
                                        <div className="testimonials__content__top__picture">
                                            <img src={element.picture} alt={element.name} className={"testimonials__content__top__picture-inner"} />
                                        </div>
                                        <div className="testimonials__content__top__quote">
                                            <div className="testimonials__content__top__quote__icon">
                                                <IconQuote className="testimonials__content__top__quote__icon--inner" />
                                            </div>
                                            <div className="testimonials__content__top__quote__content text-color-light">
                                                {element.quote}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="testimonials__content__bottom">
                                        <div className="text-bold text-color-light">
                                            {element.name}
                                        </div>
                                        <div className="text-color-light">
                                            {element.role}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div onClick={() => this.setPage(this.state.number + 1)} className="testimonials__content__arrow testimonials__content__arrow--right">
                                <IconArrow className="testimonials__content__arrow-inner" />
                            </div>

                        </div>
                        <div className="testimonials__footer-wrapper">
                            {(this.props.data && this.props.data.length >= 1) && this.props.data.map((element, i) =>
                                <div key={i} onClick={() => this.setPage(i)} className={"testimonials__footer__dot" + (i === this.state.number ? " testimonials__footer__dot--selected" : "")}></div>
                            )}
                        </div>
                    </div>
                }
            </div>
        )
    }
}
